import {
  useGetContext,
  useGetSharedFunctionality,
} from '../../api/lending/lapiHooks';

export function useSoleTraderPilot() {
  const { context } = useGetContext();
  const { functionality } = useGetSharedFunctionality({
    functionalities: ['new_st_approvals_enabled'],
  });

  return {
    eligible: context.isOnSoleTraderPilot,
    acceptingNewApprovals: functionality?.new_st_approvals_enabled || false,
  };
}
